var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12 2 A 10 10 0 0 1 20.485 6.515 L 17.071 9.929 A 5 5 0 0 0 12 7 Z",
    fill: "#B3D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.485 6.515 A 10 10 0 0 1 20.485 17.485 L 17.071 14.071 A 5 5 0 0 0 17.071 9.929 Z",
    fill: "white",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.485 17.485 A 10 10 0 0 1 12 22 L 12 17 A 5 5 0 0 0 17.071 14.071 Z",
    fill: "white",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 12 22 A 10 10 0 0 1 3.515 17.485 L 6.929 14.071 A 5 5 0 0 0 12 17 Z",
    fill: "white",
    opacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.515 17.485 A 10 10 0 0 1 3.515 6.515 L 6.929 9.929 A 5 5 0 0 0 6.929 14.071 Z",
    fill: "white",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.515 6.515 A 10 10 0 0 1 12 2 L 12 7 A 5 5 0 0 0 6.929 9.929 Z",
    fill: "white",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDark);
export default __webpack_public_path__ + "static/media/dashboard_dark.00e718b273f771d2429037b781e776f9.svg";
export { ForwardRef as ReactComponent };